"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovalSheetManagementContext = void 0;
var react_1 = require("react");
exports.ApprovalSheetManagementContext = react_1.createContext({
    isEditSheet: false,
    setIsEditSheetTrue: function () { },
    setIsEditSheetFalse: function () { },
    isAddGroupModalOpen: false,
    setIsAddGroupModalOpenTrue: function () { },
    setIsAddGroupModalOpenFalse: function () { },
    groupsUpdated: [],
    setGroupsUpdated: function () { },
    editGroup: null,
    setEditGroup: function () { },
});
